import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CodeAndBestPracticeType } from '../../hooks/useNeedsCertQARecords';


interface UIState {
  answeredByCertModalData: {
    titles: string[];
    arCodes: CodeAndBestPracticeType[];
    bpCodes: CodeAndBestPracticeType[];
  } | null;
}
const initialState: UIState = {
  answeredByCertModalData: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setAnsweredByCertModalData(state, action: PayloadAction<UIState['answeredByCertModalData']>) {
      state.answeredByCertModalData = action.payload;
    },
  },
});

export const { setAnsweredByCertModalData } = uiSlice.actions;
export default uiSlice.reducer;